import { useCallback, useRef } from 'react';
import { getSocket } from '@/lib/socket';

/** Receivers show «печатает» for 6 s (TYPING_TTL_MS); a ping every 3 s keeps it continuous. */
export const TYPING_EMIT_INTERVAL_MS = 3_000;

/**
 * «печатает» for the composer: at most one `typing:start` per interval while
 * the user types, instead of one per keystroke — every emit is fanned out to
 * everyone in the channel. `resetTyping` after a send lets the next keystroke
 * announce a new message straight away.
 */
export function useTypingEmitter(channelId: string) {
  const lastAtRef = useRef(0);

  const emitTyping = useCallback(() => {
    const now = Date.now();
    if (now - lastAtRef.current < TYPING_EMIT_INTERVAL_MS) return;
    const socket = getSocket();
    if (!socket.connected) return;
    lastAtRef.current = now;
    socket.emit('typing:start', { channelId });
  }, [channelId]);

  const resetTyping = useCallback(() => {
    lastAtRef.current = 0;
  }, []);

  return { emitTyping, resetTyping };
}
